import { useContext, useCallback } from 'react';

import { ImportStateContext } from '../components/ImportStateContextProvider.tsx';
import { ImportModalTypes } from '../components/Modals/ImportModalTypes.ts';

export const useShowRestrictionWarningModal = (): (() => Promise<boolean>) => {
	const { showConfirmModal } = useContext(ImportStateContext);

	return useCallback(
		async (): Promise<boolean> => showConfirmModal(ImportModalTypes.RESTRICTION),
		[showConfirmModal],
	);
};
